<app-tabs-layout aria-label="Messages list tabs" [tabs]="tabs" class="grow overflow-hidden p-[2px]" />
